import React, { useState } from "react";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import { patchApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import { Input } from "antd";

const CustomerUpdateSubSection = ({
  onOpen,
  onClose,
  clientId,
  subSectionId,
  subSectionName,
  popupData,
  setPopupData,
  setQuestionOpen,
}) => {
  const [subSection, setsubSection] = useState(subSectionName);
  const [error, setError] = useState(false);

  const handleClear = () => {
    setsubSection("");
    setError(false);
    onClose();
  };

  const createsubSection = async (subSection, clientId, subSectionId) => {
    try {
      const body = {
        client_id: clientId,
        // status: "Active",
        name: subSection,
        description: "This is description",
      };
      const response = await patchApi({
        apiUrl: API_URLS.UPDATE_CUSTOMER_SUBSECTION(subSectionId),
        data: body,
        headers: { client: clientId },
      });
      if (response.success) {
        setPopupData({
          type: "success",
          title: "Sub Section Updated",
          message: "Sub Section successfully Updated.",
        });
        onClose();
      } else {
        setPopupData({
          type: "warning",
          title: "Failed in Updating Sub Section",
          message: `${response.message}`,
        });
        onClose();
      }
    } catch (error) {
      console.log("Error in creating new subSection", error);
      setPopupData({
        type: "error",
        title: "Updation Failed",
        message:
          error.message || "There was a problem updating the sub section.",
      });
      onClose();
    }
  };

  const handleSave = async () => {
    if (!subSection.trim()) {
      setError(true);
      return;
    }
    await createsubSection(subSection, clientId, subSectionId);
  };

  return (
    <div className="flex justify-center my-4">
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="750px">
        <div>
          <h3 className="text-2xl">Edit subSection</h3>
          <div
            style={{
              border: "1px solid #ebedf3",
              borderRadius: "10px",
              padding: "20px",
            }}
          >
            <div className="mb-4">
              <p className="text-base font-light px-2">subSection* </p>
              <Input
                value={subSection}
                onChange={(e) => setsubSection(e.target.value)}
                placeholder="Enter subSection Name"
                style={{
                  border: "1px solid #ebedf3",
                  borderRadius: "10px",
                  padding: "10px",
                }}
                className="text-base font-light"
              />
              {error && (
                <p className="text-red-500 text-sm mt-2">
                  Please fill out this field.
                </p>
              )}
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-center gap-4 py-6">
            <CustomButton
              buttonType="primary"
              variant="cancel"
              buttonText="Cancel"
              className="text-sm px-6 py-2 rounded-lg"
              onClick={handleClear}
            />
            <CustomButton
              buttonType="primary"
              variant="ok"
              buttonText="Save"
              className=" text-sm px-6 py-2 rounded-lg"
              onClick={handleSave}
            />
          </div>
        </div>
      </DailogBox>
    </div>
  );
};

export default CustomerUpdateSubSection;
